var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.273,
    height: 46.368,
    viewBox: "0 0 42.273 46.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M0,0H42.273V46.368H0Z",
    transform: "translate(-701 3612)",
    fill: "#e5ccd1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_79",
    "data-name": "Mask Group 79",
    transform: "translate(701 -3612)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "communication-2-svgrepo-com_1_",
    "data-name": "communication-2-svgrepo-com (1)",
    transform: "translate(-695.859 3612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26512",
    "data-name": "Path 26512",
    d: "M449.009,670.789a8.588,8.588,0,1,0-8.588-8.588A8.588,8.588,0,0,0,449.009,670.789Z",
    transform: "translate(-437.913 -639.222)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26513",
    "data-name": "Path 26513",
    d: "M757.119,1475.054l1.615,2.01,1.615-2.01-.217-2.516h-2.794Z",
    transform: "translate(-747.638 -1440.117)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26514",
    "data-name": "Path 26514",
    d: "M344.868,1482.358a1.169,1.169,0,0,0-1.263-.086,11.983,11.983,0,0,1-2.007.9l-4,4.985-4-4.985a11.983,11.983,0,0,1-2.007-.9,1.169,1.169,0,0,0-1.263.086,14.893,14.893,0,0,0-3.726,6.411c-.942,5.21,5.1,7.093,11,7.093s11.94-1.883,11-7.093A14.892,14.892,0,0,0,344.868,1482.358Zm-7.272,10.329a1.156,1.156,0,1,1,1.156-1.156A1.157,1.157,0,0,1,337.6,1492.687Z",
    transform: "translate(-326.5 -1449.494)",
    fill: "#e5ccd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26515",
    "data-name": "Path 26515",
    d: "M859.967,0H852.2a6.4,6.4,0,1,0,0,12.791h6.11c.913,0,1.2.424,1.2.772a1.792,1.792,0,0,1-.913,1.456c-.4.285-.086.513.228.513,4.083,0,7.538-4.454,7.538-9.137A6.4,6.4,0,0,0,859.967,0Zm-8.739,7.61A1.215,1.215,0,1,1,852.442,6.4,1.214,1.214,0,0,1,851.228,7.61Zm4.856,0A1.215,1.215,0,1,1,857.3,6.4,1.215,1.215,0,0,1,856.084,7.61Zm4.856,0A1.215,1.215,0,1,1,862.155,6.4,1.214,1.214,0,0,1,860.941,7.61Z",
    transform: "translate(-834.372)",
    fill: "#e5ccd1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/Tree.dfdfe477f7eb1b834cb3948595423f02.svg";
export { ForwardRef as ReactComponent };